import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/maps'
        render={(routeProps) => (
          <PageLayout>
            {require('./Merchants').default(routeProps)}
            {require('./PowerBankStore').default(routeProps)}
          </PageLayout>
        )}
      />
    </Switch>
  )
}

export default AppRouter
